import {
  TRANSACTION_NOT_FOUND_ERROR_CODE,
  TRANSACTION_NOT_FOUND_ERROR_MESSAGE,
  TRANSACTION_BILL_ALREADY_PAID_ERROR_CODE,
  TRANSACTION_BILL_ALREADY_PAID_ERROR_MESSAGE,
} from '~/components/Buka20/constant';

export function getInquiryCustomErrorMessage(error) {
  if (error?.errors?.[0]?.code === TRANSACTION_NOT_FOUND_ERROR_CODE) {
    return TRANSACTION_NOT_FOUND_ERROR_MESSAGE;
  }
  if (error?.errors?.[0]?.code === TRANSACTION_BILL_ALREADY_PAID_ERROR_CODE) {
    return TRANSACTION_BILL_ALREADY_PAID_ERROR_MESSAGE;
  }
  return '';
}
